import { render } from "./AdminSysConfigTab.vue?vue&type=template&id=d91f9f8c&ts=true"
import script from "./AdminSysConfigTab.vue?vue&type=script&lang=ts"
export * from "./AdminSysConfigTab.vue?vue&type=script&lang=ts"

import "./AdminSysConfigTab.vue?vue&type=style&index=0&id=d91f9f8c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__